import catalog from './permissions.catalog.json';

const UserPermissionTypes = catalog.user;
const LearningCenterPermissionTypes = catalog.learningCenter;
const KitsPermissionTypes = catalog.kits;

/** View Permissions */
export const CAN_VIEW_ADMIN = [UserPermissionTypes.canViewAdmin];
export const CAN_VIEW_APERTURE = [UserPermissionTypes.canViewAperture];
export const CAN_VIEW_KITS_UI = [KitsPermissionTypes.canViewKitsUI];

/** Academy permissions — from user roles (PortalApi RoleRecords) */
export const CAN_VIEW_ACADEMY = [LearningCenterPermissionTypes.canViewAcademy];
export const CAN_VIEW_ACADEMY_VERUS_LAB = [LearningCenterPermissionTypes.canViewAcademyVerusLab];
export const CAN_VIEW_ACADEMY_VERUS_RESEARCHER = [LearningCenterPermissionTypes.canViewAcademyVerusResearcher];
/** Any Learning Center branch permission — gates home page card visibility */
export const CAN_VIEW_ANY_LEARNING_CENTER = [
	...CAN_VIEW_ACADEMY,
	...CAN_VIEW_ACADEMY_VERUS_LAB,
	...CAN_VIEW_ACADEMY_VERUS_RESEARCHER,
];
/** Any Verus academy branch permission — excludes general Metabolon Academy */
export const CAN_VIEW_ANY_VERUS_ACADEMY = [
	...CAN_VIEW_ACADEMY_VERUS_LAB,
	...CAN_VIEW_ACADEMY_VERUS_RESEARCHER,
];

/** Edit Permissions */
export const CAN_EDIT_USERS = [UserPermissionTypes.canEditUsers];
export const CAN_EDIT_ROLE_PERMISSIONS = [UserPermissionTypes.canEditRolePermissions];
export const CAN_EDIT_PROJECTS = [UserPermissionTypes.canEditProjects];
export const CAN_EDIT_STATUS = [UserPermissionTypes.canEditStatus];

export {
	UserPermissionTypes,
	LearningCenterPermissionTypes,
	KitsPermissionTypes,
};

export const ALL_PERMISSIONS = [
	...Object.values(UserPermissionTypes),
	...Object.values(LearningCenterPermissionTypes),
	...Object.values(KitsPermissionTypes),
].sort();
